import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Stack, Card, CardContent, Grid, CardHeader } from '@mui/material';
import { useEntityForm } from '../../../entities/hooks';
import { TextFieldController } from '../../../../components/inputs';
import { LOCALE_CR, LOCALE_UZ, LOCALE_RU } from '../../../../common/constants';
import { REGIONS_NAME, REGIONS_CODE } from '../../constants';
import { IconClearAll, IconSave } from '../../../../common/icons';
import { IForm } from '../../../../common/models';
import { RegionsSchema } from '../../schema';
import { IRegions } from '../../models';

export const RegionsForms: FC<IForm<IRegions>> = ({ defaultValues, onValid, isLoading }) => {
  const { t } = useTranslation();
  const { control, onReset, onSubmit } = useEntityForm<IRegions>({
    schema: RegionsSchema,
    defaultValues,
    onValid,
  });

  return (
    <Box onSubmit={onSubmit} component="form">
      <Stack direction="row" justifyContent="flex-end" spacing={1.5} mb={2.5}>
        <Button
          type="reset"
          variant="contained"
          color="secondary"
          startIcon={<IconClearAll />}
          disabled={isLoading}
          onClick={onReset}
        >
          {t('action.clear')}
        </Button>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          startIcon={<IconSave />}
          disabled={isLoading}
        >
          {t('action.save')}
        </Button>
      </Stack>
      <Card>
        <CardHeader title={t('regions.form.title')} />
        <CardContent>
          <Grid container spacing={2.5}>
            <Grid item xs={12} md={6} lg={3}>
              <TextFieldController
                control={control}
                name={[REGIONS_NAME, LOCALE_CR].join('.')}
                disabled={isLoading}
                label={t('regions.field.name.cr')}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <TextFieldController
                control={control}
                name={[REGIONS_NAME, LOCALE_UZ].join('.')}
                disabled={isLoading}
                label={t('regions.field.name.uz')}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <TextFieldController
                control={control}
                name={[REGIONS_NAME, LOCALE_RU].join('.')}
                disabled={isLoading}
                label={t('regions.field.name.ru')}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <TextFieldController
                control={control}
                name={REGIONS_CODE}
                disabled={isLoading}
                label={t('regions.field.code')}
                fullWidth
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};
